import request from '@/utils/request'

/**
 * 查询标签
 * @param {Object} params 
 * @returns 
 */
export function listTag(params) {
  return request({
    url: '/tag/tag/list',
    method: 'GET',
    params,
  })
}

/**
 * 添加标签
 * @param {Object} data 
 * @returns 
 */
export function addTag(data) {
  return request({
    url: '/tag/tag/insert',
    method: 'POST',
    data,
  })
}


/**
 * 修改标签
 * @param {Object} data 
 * @returns 
 */
export function updateTag(data) {
  return request({
    url: '/tag/tag/update',
    method: 'POST',
    data,
  })
}


/**
 * 删除
 * @param {Object} data 
 * @returns 
 */
export function delTag(data) {
  return request({
    url: '/tag/tag/remove',
    method: 'POST',
    data,
  })
}

